import { useCallback, useState } from "react";
import CheckIcon from "../assets/icons/bible_modal_window_icons/check_icon";
import CancelIcon from "../assets/icons/bible_modal_window_icons/cancel_icon";

const sharedButtonClass =
	"flex items-center justify-center h-8 w-[26px] rounded-md transition-all duration-200 opacity-60";

const InputControlButtons = ({ showSaveButton = true, onClickCancelButton, onClickSaveButton }) => {
	const [isHoverOnCancel, setIsHoverOnCancel] = useState(false);

	const toggleHoverOnCancelButton = useCallback(() => {
		setIsHoverOnCancel(prevState => !prevState);
	}, []);

	return (
		<div
			className="absolute top-1/2 right-2 -translate-y-1/2 flex items-center gap-1.5 z-[9] bg-white dark:bg-dark-gray-raised"
			data-testid="control-buttons"
		>
			<button
				type="button"
				className={`${sharedButtonClass} hover:opacity-100`}
				onMouseEnter={toggleHoverOnCancelButton}
				onMouseLeave={toggleHoverOnCancelButton}
				onClick={onClickCancelButton}
				data-testid="cancel-button"
			>
				<CancelIcon style={{ height: "18px", width: "18px" }} />
			</button>

			{showSaveButton && (
				<button
					type="button"
					className={`${sharedButtonClass} ${isHoverOnCancel ? "opacity-60" : "opacity-100"}`}
					onClick={onClickSaveButton}
					data-testid="save-button"
				>
					<CheckIcon style={{ height: "18px", width: "18px" }} />
				</button>
			)}
		</div>
	);
};

export default InputControlButtons;
